import { useState } from "react";
import { Link } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import Breadcrumb from "@/components/feature/Breadcrumb";

const faqs = [
  {
    q: "鸭王在线观看提供哪些内容？",
    a: "本站聚合动作、喜剧、爱情、科幻、悬疑、动画等多种类型的电影资源，提供分类浏览、关键词搜索与影片详情展示，方便你快速找到想看的影片。",
  },
  {
    q: "可以在本站直接观看影片吗？",
    a: "本站为影视内容展示站点，播放区域目前为前端演示入口，暂未接入真实播放服务。后续将陆续完善相关能力。",
  },
  {
    q: "内容多久更新一次？",
    a: "我们会持续整理并更新最新电影资源，保持分类清晰、信息及时，建议收藏本站以便随时回来查看。",
  },
  {
    q: "需要注册或付费吗？",
    a: "本站不设会员注册、播放授权或付费功能，所有类型浏览、搜索与详情展示均可直接使用。",
  },
];

export default function About() {
  useDocumentTitle(
    "关于我们 - 鸭王在线观看",
    "了解鸭王在线观看的网站定位、服务宗旨与常见问题，联系我们获取更多影视资讯与支持。"
  );

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <section className="mt-6 overflow-hidden rounded-lg border border-background-200/60 bg-background-100">
        <div className="grid grid-cols-1 gap-0 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-movie-2-line"></i>
              关于我们
            </span>
            <h1 className="mt-4 font-heading text-3xl font-extrabold text-foreground-950 md:text-4xl">
              关于鸭王在线观看
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              鸭王在线观看是一家专注于提供最新电影资源与在线观看体验的影视内容平台，面向广大电影爱好者，尤其是喜欢在线观看高清免费电影的用户群体。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们注重内容的丰富性与观看体验的流畅性，坚持资源更新及时、分类清晰、操作简便。无论你想追最新上映的影片，还是按类型慢慢挑选，都能在这里轻松找到。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-home-4-line text-lg"></i>
                返回首页
              </Link>
              <Link
                to="/category/action"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:border-accent-500 hover:text-accent-500"
              >
                <i className="ri-apps-2-line text-lg"></i>
                浏览电影分类
              </Link>
            </div>
          </div>

          <div className="relative hidden min-h-[320px] lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20rows%20of%20red%20seats%20and%20a%20large%20glowing%20screen%2C%20warm%20ambient%20lighting%2C%20dramatic%20atmospheric%20mood%2C%20high%20detail%2C%20deep%20blue%20and%20amber%20tones&width=800&height=900&seq=yw-about-01&orientation=portrait"
              alt="鸭王在线观看影视内容平台"
              title="鸭王在线观看 - 影视内容平台"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-100 to-transparent"></div>
          </div>
        </div>
      </section>

      <section className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[
          { icon: "ri-film-line", value: "24+", label: "精选影片资源" },
          { icon: "ri-apps-2-line", value: "12", label: "电影类型分类" },
          { icon: "ri-refresh-line", value: "每日", label: "持续更新资源" },
        ].map((item) => (
          <div
            key={item.label}
            className="flex items-center gap-4 rounded-lg border border-background-200/60 bg-background-100 p-5"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
              <i className={`${item.icon} text-2xl`}></i>
            </span>
            <div>
              <p className="font-heading text-xl font-bold text-foreground-950">{item.value}</p>
              <p className="text-sm text-foreground-600">{item.label}</p>
            </div>
          </div>
        ))}
      </section>

      <section className="mt-10">
        <div className="mb-5 flex items-center gap-3">
          <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl font-bold text-foreground-950">常见问题</h2>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-lg border border-background-200/60 bg-background-100"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">
                    {faq.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl text-accent-500 transition-transform ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <p className="animate-fade-in px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </section>

      <section className="mt-10 rounded-lg border border-background-200/60 bg-background-100 p-6 md:p-8">
        <h2 className="font-heading text-xl font-bold text-foreground-950">联系我们</h2>
        <p className="mt-2 text-sm text-foreground-600">
          如对本站内容有任何建议或问题，欢迎通过以下方式与我们取得联系（以下邮箱为演示示例）。
        </p>
        <div className="mt-5 flex flex-wrap gap-4">
          <div className="flex items-center gap-3 rounded-lg bg-secondary-500/20 px-4 py-3">
            <i className="ri-mail-line text-xl text-accent-500"></i>
            <div>
              <p className="text-xs text-foreground-600">邮箱</p>
              <p className="text-sm text-foreground-950">support@yawang-demo.example</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-lg bg-secondary-500/20 px-4 py-3">
            <i className="ri-time-line text-xl text-accent-500"></i>
            <div>
              <p className="text-xs text-foreground-600">服务时间</p>
              <p className="text-sm text-foreground-950">每日 09:00 - 23:00</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}